import { Guid } from "./Types";

/**
 * Keys for Storyblok Datasource entries for labels
 */

// PLEASE KEEP THEM SORTED ALPHABETICALLY
export enum LabelKey {
  accommodationOfYourChoice = "accommodationOfYourChoice",
  addButton = "addButton",
  addInvoiceEmail = "addInvoiceEmail",
  addOptionalItems = "addOptionalItems",
  address = "address",
  agreeToPrivacyPolicy = "agreeToPrivacyPolicy",
  agreeToTermsAndConditions = "agreeToTermsAndConditions",
  amount = "amount",
  back = "back",
  beneficiary = "beneficiary",
  birthCountry = "birthCountry",
  birthCity = "birthCity",
  bookByPartialPayment = "bookByPartialPayment",
  bookingConditions = "bookingConditions",
  bookingConfirmation = "bookingConfirmation",
  bookingConfirmationContent = "bookingConfirmationContent",
  bookNow = "bookNow",
  bookNowLabel = "bookNowLabel",
  cancel = "cancel",
  change = "change",
  changeAccommodationTo = "changeAccommodationTo",
  changeAccommodationDescription = "changeAccommodationDescription",
  city = "city",
  completeBooking = "completeBooking",
  completePaymentDetails = "completePaymentDetails",
  completePaymentDetailsContent = "completePaymentDetailsContent",
  confirm = "confirm",
  confirmAndPay = "confirmAndPay",
  contactUs = "contactUs",
  country = "country",
  countryOfNationality = "countryOfNationality",
  creditOrDebitCard = "creditOrDebitCard",
  currentAccommodation = "currentAccommodation",
  dateOfBirth = "dateOfBirth",
  daysRemaining = "daysRemaining",
  deferredPayment = "deferredPayment",
  deferredPaymentPlan = "deferredPaymentPlan",
  deferredPaymentPlanBody = "deferredPaymentPlanBody",
  deferredPaymentDetails = "deferredPaymentDetails",
  descriptionSalesUser = "descriptionSalesUser",
  discount = "discount",
  discoverDestination = "discoverDestination",
  downPayment = "downPayment",
  downPaymentDetails = "downPaymentDetails",
  downPaymentLabel = "downPaymentLabel",
  downloadCampusConnect = "downloadCampusConnect",
  downloadCampusConnectBulletPoint_1 = "downloadCampusConnectBulletPoint_1",
  downloadCampusConnectBulletPoint_2 = "downloadCampusConnectBulletPoint_2",
  downloadCampusConnectBulletPoint_3 = "downloadCampusConnectBulletPoint_3",
  downloadCampusConnectBulletPoint_4 = "downloadCampusConnectBulletPoint_4",
  downloadCampusConnectContent = "downloadCampusConnectContent",
  duration2to4Weeks = "duration2to4Weeks",
  duration5orMoreWeeks = "duration5orMoreWeeks",
  durationUpgradeDescription = "durationUpgradeDescription",
  durationWeek = "durationWeek",
  durationWeeks = "durationWeeks",
  efEducationFirst = "efEducationFirst",
  email = "email",
  error = "error",
  finePrintPaymentText = "finePrintPaymentText",
  firstName = "firstName",
  fullName = "fullName",
  firstNameLatin = "firstNameLatin",
  fullPayment = "fullPayment",
  fullPaymentDetails = "fullPaymentDetails",
  fullPaymentLabel = "fullPaymentLabel",
  gender = "gender",
  goToReservationButton = "goToReservationButton",
  headerAccommodation = "headerAccommodation",
  headerCourses = "headerCourses",
  headerGeneralFees = "headerGeneralFees",
  headerInsurance = "headerInsurance",
  headerOther = "headerOther",
  headerSalesUser = "headerSalesUser",
  headerTransfer = "headerTransfer",
  headerWeeks = "headerWeeks",
  hideDetails = "hideDetails",
  howManyWeeksToAdd = "howManyWeeksToAdd",
  included = "included",
  includedInDestinationPrice = "includedInDestinationPrice",
  infoSheet = "infoSheet",
  installmentLabel = "installmentLabel",
  installmentLabelFirst = "installmentLabelFirst",
  installmentLabelLast = "installmentLabelLast",
  installmentPayments = "installmentPayments",
  installmentPaymentsDetails = "installmentPaymentsDetails",
  invoiceEmail = "invoiceEmail",
  lastName = "lastName",
  lastNameLatin = "lastNameLatin",
  medicalDetails_allergies = "medicalDetails_allergies",
  medicalDetails_allergy_dust = "medicalDetails_allergy_dust",
  medicalDetails_allergy_insect = "medicalDetails_allergy_insect",
  medicalDetails_allergy_nuts = "medicalDetails_allergy_nuts",
  medicalDetails_allergy_other = "medicalDetails_allergy_other",
  medicalDetails_allergy_penicilin = "medicalDetails_allergy_penicilin",
  medicalDetails_allergy_pets = "medicalDetails_allergy_pets",
  medicalDetails_allergy_pollen = "medicalDetails_allergy_pollen",
  medicalDetails_dietaryNeeds = "medicalDetails_dietaryNeeds",
  medicalDetails_dietaryNeeds_description = "medicalDetails_dietaryNeeds_description",
  medicalDetails_dietary_glutenFree = "medicalDetails_dietary_glutenFree",
  medicalDetails_dietary_halal = "medicalDetails_dietary_halal",
  medicalDetails_dietary_kosher = "medicalDetails_dietary_kosher",
  medicalDetails_dietary_lactoseFree = "medicalDetails_dietary_lactoseFree",
  medicalDetails_dietary_other = "medicalDetails_dietary_other",
  medicalDetails_dietary_vegan = "medicalDetails_dietary_vegan",
  medicalDetails_dietary_vegetarian = "medicalDetails_dietary_vegetarian",
  medicalDetails_disability_deaf = "medicalDetails_disability_deaf",
  medicalDetails_disability_other = "medicalDetails_disability_other",
  medicalDetails_disability_visuallyImpaired = "medicalDetails_disability_visuallyImpaired",
  medicalDetails_disability_usesWheelchair = "medicalDetails_disability_usesWheelchair",
  medicalDetails_medical_other = "medicalDetails_medical_other",
  medicalDetails_medicalNeeds = "medicalDetails_medicalNeeds",
  medicalDetails_medicalNeeds_asthmatic = "medicalDetails_medicalNeeds_asthmatic",
  medicalDetails_medicalNeeds_description = "medicalDetails_medicalNeeds_description",
  medicalDetails_medicalNeeds_diabetic = "medicalDetails_medicalNeeds_diabetic",
  medicalDetails_medicalNeeds_epileptic = "medicalDetails_medicalNeeds_epileptic",
  medicalDetails_medicalNeeds_medications = "medicalDetails_medicalNeeds_medications",
  medicalDetails_cannot_update_now = "medicalDetails_cannot_update_now",
  medicalDetails_form_values_invalid = "medicalDetails_form_values_invalid",
  middleName = "middleName",
  middleNameLatin = "middleNameLatin",
  missingCountry = "missingCountry",
  missingDateOfBirth = "missingDateOfBirth",
  missingDetails = "missingDetails",
  missingEmail = "missingEmail",
  missingGender = "missingGender",
  missingLatinDetails = "missingLatinDetails",
  missingNationality = "missingNationality",
  missingPrivacyPolicy = "missingPrivacyPolicy",
  missingTerms = "missingTerms",
  monthlyPayments = "monthlyPayments",
  monthlyPaymentsDetails = "monthlyPaymentsDetails",
  mostPopular = "mostPopular",
  myPriceQuotations = "myPriceQuotations",
  nationality = "nationality",
  nationalId = "nationalId",
  no = "no",
  noOfWeeks = "noOfWeeks",
  numberOfWeeks = "numberOfWeeks",
  optionalItemsAdditionalDescription = "optionalItemsAdditionalDescription",
  original = "original",
  originalDuration = "originalDuration",
  orPayLater = "orPayLater",
  paid = "paid",
  paidAmount = "paidAmount",
  paidInLocalCurrencyNote = "paidInLocalCurrencyNote",
  paidReservationAmount = "paidReservationAmount",
  parentDetails = "parentDetails",
  parentDetailsDescription = "parentDetailsDescription",
  parentRelationship = "parentRelationship",
  payByBank = "payByBank",
  payByBankDisclaimer = "payByBankDisclaimer",
  payCustomAmountTitle = "payCustomAmountTitle",
  payCustomAmountSubtitle = "payCustomAmountSubtitle",
  payment = "payment",
  paymentAmountOutOfRange = "paymentAmountOutOfRange",
  paymentInformation = "paymentInformation",
  paymentIsBeingProcessed = "paymentIsBeingProcessed",
  paymentMethod = "paymentMethod",
  paymentCurrencySelector_title = "paymentCurrencySelector_title",
  paymentCurrencyDisclaimer_usd = "paymentCurrencyDisclaimer_usd",
  paymentCurrencyDisclaimer_local = "paymentCurrencyDisclaimer_local",
  paymentCurrencyDisclaimer_installments = "paymentCurrencyDisclaimer_installments",
  paymentPlan = "paymentPlan",
  paymentReferenceNumber = "paymentReferenceNumber",
  paymentsMade = "paymentsMade",
  paymentStatus_PaymentFailureHeader = "paymentStatus_PaymentFailureHeader",
  paymentStatus_PaymentFailureMessage = "paymentStatus_PaymentFailureMessage",
  paymentStatus_PaymentProcessedHeader = "paymentStatus_PaymentProcessedHeader",
  paymentStatus_PaymentSuccessHeader = "paymentStatus_PaymentSuccessHeader",
  paymentStatus_ReservationFailureHeader = "paymentStatus_ReservationFailureHeader",
  paymentStatus_ReservationFailureMessage = "paymentStatus_ReservationFailureMessage",
  paymentStatus_ReservationSuccessHeader = "paymentStatus_ReservationSuccessHeader",
  paymentStatus_ReservationSuccessMessage = "paymentStatus_ReservationSuccessMessage",
  paymentStatus_ThankYouMessage = "paymentStatus_ThankYouMessage",
  payNow = "payNow",
  payOnline = "payOnline",
  passportNumber = "passportNumber",
  passportDetails = "passportDetails",
  passportGivenName = "passportGivenName",
  passportSurname = "passportSurname",
  passportDetailsDescription = "passportDetailsDescription",
  payToday = "payToday",
  payNowDiscount = "payNowDiscount",
  preferredLanguage = "preferredLanguage",
  preferredTooltip = "preferredTooltip",
  pdf = "pdf",
  pending = "pending",
  phoneCallButton = "phoneCallButton",
  phoneNumber = "phoneNumber",
  pleaseWait = "pleaseWait",
  pleaseWaitRequest = "pleaseWaitRequest",
  priceDetails = "priceDetails",
  privacyPolicy = "privacyPolicy",
  postalCode = "postalCode",
  postReservationCampusConnectSection_appStoreCtaEyebrowText = "postReservationCampusConnectSection_appStoreCtaEyebrowText",
  postReservationCampusConnectSection_eyebrowText = "postReservationCampusConnectSection_eyebrowText",
  postReservationCampusConnectSection_getAppCtaLabel = "postReservationCampusConnectSection_getAppCtaLabel",
  postReservationCampusConnectSection_googlePlayEyebrowText = "postReservationCampusConnectSection_googlePlayEyebrowText",
  postReservationCampusConnectSection_qrCodeLabel = "postReservationCampusConnectSection_qrCodeLabel",
  postReservationCampusConnectSection_title = "postReservationCampusConnectSection_title",
  quoteId = "quoteId",
  quotePaidOn = "quotePaidOn",
  quotePricePerWeek = "quotePricePerWeek",
  preferredQuote = "preferredQuote",
  quotePriceTotal = "quotePriceTotal",
  quoteSaved = "quoteSaved",
  quoteValidUntil = "quoteValidUntil",
  recurring = "recurring",
  referenceNumber = "referenceNumber",
  remaining = "remaining",
  removeButton = "removeButton",
  requestIsBeingProcessed = "requestIsBeingProcessed",
  reservationFor24Hours = "reservationFor24Hours",
  reserve = "reserve",
  reserved = "reserved",
  reserveFor = "reserveFor",
  reserveNow = "reserveNow",
  reviewDetailsAndReserve = "reviewDetailsAndReserve",
  save = "save",
  saveAndContinue = "saveAndContinue",
  continue = "continue",
  saveAndPay = "saveAndPay",
  saveAsNew = "saveAsNew",
  saveDetails = "saveDetails",
  saveFailed = "saveFailed",
  saveFailedDescription = "saveFailedDescription",
  schoolName = "schoolName",
  scholarshipDetails = "scholarshipDetails",
  scholarshipFunding = "scholarshipFunding",
  seeAll = "seeAll",
  seeLess = "seeLess",
  seeWhatsNext = "seeWhatsNext",
  segmentPricePerWeek = "segmentPricePerWeek",
  segmentTotalPrice = "segmentTotalPrice",
  selectButton = "selectButton",
  selectPaymentMethod = "selectPaymentMethod",
  sendEmailButton = "sendEmailButton",
  sendMessageButton = "sendMessageButton",
  sendMessageButtonMobile = "sendMessageButtonMobile",
  setAsPreferred = "setAsPreferred",
  showDetails = "showDetails",
  showThreeInstallmentsAlternative = "showThreeInstallmentsAlternative",
  sortBy = "sortBy",
  sortBy_Created = "sortBy_Created",
  sortBy_Destination = "sortBy_Destination",
  sortBy_Duration = "sortBy_Duration",
  sortBy_TotalPrice = "sortBy_TotalPrice",
  sortBy_WeeklyPrice = "sortBy_WeeklyPrice",
  splitYourPayment = "splitYourPayment",
  splitYourPaymentDetails = "splitYourPaymentDetails",
  status = "status",
  studentBasicInformation = "studentBasicInformation",
  studentDetails = "studentDetails",
  studentDetailsDescription = "studentDetailsDescription",
  studentDetailsFullUpgradeDescription = "studentDetailsFullUpgradeDescription",
  studentDetailsFullUpgradeThankYouMessage = "studentDetailsFullUpgradeThankYouMessage",
  studentDetailsFullUpgradeThankYouMessageDescription = "studentDetailsFullUpgradeThankYouMessageDescription",
  studentDetailsFullUpgradeThankYouMessageCompletePayment = "studentDetailsFullUpgradeThankYouMessageCompletePayment",
  studentDetailsFullUpgradeThankYouMessageGoToReservation = "studentDetailsFullUpgradeThankYouMessageGoToReservation",
  studentDetailsSaved = "studentDetailsSaved",
  studentLatinDetails = "studentLatinDetails",
  studentUpdateSteps = "studentUpdateSteps",
  success = "success",
  summary = "summary",
  summaryOfBookingPaymentSentToEmail = "summaryOfBookingPaymentSentToEmail",
  teacherName = "teacherName",
  termsAndConditions = "termsAndConditions",
  toBePaid = "toBePaid",
  toPayNow = "toPayNow",
  total = "total",
  totalAfter = "totalAfter",
  updateStudentDetails = "updateStudentDetails",
  updateYourDetails = "updateYourDetails",
  updateYourDetailsDefaultContent = "updateYourDetailsDefaultContent",
  updateYourDetailsPendingContent = "updateYourDetailsPendingContent",
  updateYourDetailsSuccessContent = "updateYourDetailsSuccessContent",
  upgrade = "upgrade",
  upgradeAccommodation = "upgradeAccommodation",
  upgradeCost = "upgradeCost",
  upgradeCourse = "upgradeCourse",
  upgradeFailed = "upgradeFailed",
  upgradeTag = "upgradeTag",
  upgradeWeeks = "upgradeWeeks",
  validationMessage = "validationMessage",
  validationEmailMessage = "validationEmailMessage",
  valueTooLong = "valueTooLong",
  whatToExpect = "whatToExpect",
  whatsNext = "whatsNext",
  whyExtendYourCourse_Description = "whyExtendYourCourse_Description",
  whyExtendYourCourse_Title = "whyExtendYourCourse_Title",
  yes = "yes",
  suggestedReservedQuote = "suggestedReservedQuote",
  quoteStatus_Canceled = "quoteStatus_Canceled",
}

export interface BlokBase {
  _uid: Guid;
  component: string;
}

export interface SbImage {
  filename: string;
  alt: string;
  focus: string;
}

export interface SbUrl {
  linktype: string;
  url: string;
}

export type DatasourceEntry = {
  dimension_value: string;
  id: number;
  name: string;
  value: string;
};
